var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_66_1",
    "data-name": "Component 66 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 22,
    height: 16,
    fill: "#00c22d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M0,1.734A2.28,2.28,0,0,1,.681.486,1.971,1.971,0,0,1,2.024,0H15.643c1.461,0,2.922,0,4.382,0a1.938,1.938,0,0,1,1.909,1.506A2.194,2.194,0,0,1,22,2.078Q22,8,22,13.921A1.974,1.974,0,0,1,20,16Q11,16,2,16A1.944,1.944,0,0,1,.04,14.363c-.008-.035,0-.075-.04-.1Zm2.3-.387a.583.583,0,0,0,.18.269l7.093,7.3a1.989,1.989,0,0,0,.761.52,1.913,1.913,0,0,0,2.146-.575q3.5-3.612,7.016-7.217c.084-.086.162-.177.266-.293Zm-.1,13.3H19.635c-1.736-1.83-3.516-3.705-5.292-5.583-.1-.1-.154-.087-.241.006-.268.287-.543.569-.819.848a3.127,3.127,0,0,1-4.191.326,9.855,9.855,0,0,1-1.151-1.13c-.135-.141-.2-.135-.334,0Q5.1,11.7,2.582,14.282c-.11.113-.227.216-.382.362M20.7,2.291c-.05.042-.067.056-.081.071Q17.957,5.1,15.291,7.84c-.135.138-.111.206.009.328q2.653,2.721,5.3,5.448c.028.027.046.082.1.048ZM1.388,2.266l-.078.075V13.68a.372.372,0,0,0,.056-.035q2.688-2.762,5.378-5.522c.121-.123.058-.176-.022-.259C6.006,7.127,5.286,6.4,4.578,5.65,3.51,4.527,2.451,3.4,1.388,2.266",
    fill: "#00c22d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBox);
export default __webpack_public_path__ + "static/media/MessageBox.2fab7b82743ca7f14062c3dcb4612319.svg";
export { ForwardRef as ReactComponent };